import React, { useState } from 'react';
import './MeetingInsights.css';

const MeetingObjectives = ({ updatedObjectives, meetingObjectives }) => {
  const [expandedObjectives, setExpandedObjectives] = useState(new Set());

  const toggleObjective = (sectionName) => {
    const newExpanded = new Set();
    if (expandedObjectives.has(sectionName)) {
      newExpanded.delete(sectionName);
    } else {
      newExpanded.add(sectionName);
    }
    setExpandedObjectives(newExpanded);
  };

  const getCompletionColorStyle = (percentage) => {
    if (percentage >= 0.8) return 'green';
    if (percentage >= 0.5) return 'yellow';
    return 'red';
  };

  const objectives = updatedObjectives?.objectivesAnalysis?.objectives || meetingObjectives?.objectives || [];

  

  const renderObjectivesTab = () => (
    <div className="insights-section">
      <div className="objectives-list">
        {objectives && Array.isArray(objectives) && objectives.length > 0 ? (
          objectives.map((objective, index) => {
            const sectionName = objective.section;
            const tasks = objective.tasks;
            const completionPercentage = objective.percentCompleted || 0;
            const isExpanded = expandedObjectives.has(sectionName);
            
            
            
            return (
              <div key={index} className="objective-item">
                <div 
                  className="objective-header"
                  onClick={() => toggleObjective(sectionName)}
                >
                  <div className="objective-title">
                    <span className="objective-name">{sectionName}</span>
                    <span 
                      className={`completion-percentage ${getCompletionColorStyle(completionPercentage)}`}
                    >
                      {Math.round(completionPercentage * 100)}%
                    </span>
                  </div>
                  <div className="objective-toggle">
                    {isExpanded ? <i className="ti ti-chevron-down"/> : <i className="ti ti-chevron-right"/>}
                  </div>
                </div>
                
                {isExpanded && (
                  <div className="tasks-list">
                                                {Object.entries(tasks).map(([taskName, taskData], taskIndex) => {
                              // Extract the completed status from the task object
                              const isTaskCompleted = taskData?.completed || false;
                              
                              return (
                                <div key={taskIndex} className={`task-item ${isTaskCompleted ? 'completed' : 'pending'}`}>
                                  <span className="task-status">
                                    {isTaskCompleted ? <i className="ti ti-circle-check-filled"/> : <i className="ti ti-circle"/>}
                                  </span>
                                  <span className="task-name">{taskName}</span>
                                </div>
                              );
                            })}
                  </div>
                )}
              </div>
            );
          })
        ) : (
          <div className="empty-objectives-state">
            <div className="empty-state-icon">
              <i className="ti ti-target"></i>
            </div>
            <p className="empty-state-text">
              Meeting objectives will automatically appear here as the meeting progresses.
            </p>
          </div>
        )}
      </div>
    </div>
  );

  return (
    <div className="meeting-insights-container">
      {/* Tab Navigation */}
      <div className="insights-tabs">
        <h3>Objectives</h3>
      </div>

      {/* Tab Content */}
      <div className="insights-content">
        {renderObjectivesTab()}
      </div>
    </div>
  );
};

export default MeetingObjectives;
